import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "./private-route.js";
import HomeView from "./home-view.js";
import ProfileView from "./profile.view.js";
import BlogsView from "./blogs.view.js";
import ServicesView from "./services.view.js";
import BusinessguideView from "./businessguides.view.js";
import ExpertView from "./experts.view.js";
import GraduateView from "./graduates.view.js";
import ExpertTagManagementView from "./expert-tag-management.view.js";
import EventTagManagementView from "./event-tag-management.view.js";
import StaffView from "./staff.view.js";
import AuthView from "./auth.view.js";
import EventsView from "./events.view.js";
import ReportView from "./reports.view.js";
import ExpertCatReportView from "./expertcatreport.view.js";
import KeywordsView from "./keywords.view.js";
import memberOffersView from "./offers.view.js";
import MembersView from "./members.view.js";
import CreditsView from "./credits.view.js";
import EmailCreatorView from "./emailcreator.view.js";
import FlowchartsView from "./flowcharts.view.js";
import { useState, useEffect } from 'react';

function App() {
  const { isLoading } = useAuth0();
  //const [chatbotThreadID, setChatbotThreadID] = useState("");

  //useEffect(() => {
  //  setChatbotThreadID(sessionStorage.getItem("FaBEChatbotId") || "");
  //}, [])

  return (
    <>
       <link
            rel="stylesheet"
            href="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
            integrity="sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk"
            crossOrigin="anonymous"
          />

      {isLoading ? (
        <div className="spinnerContainer">
          <div className="spinner spinner-lg is-auth0">
            <div className="circle" />
          </div>
        </div>
      ) : (
        <Switch>
          <Route exact path="/" component={HomeView} />
          {/* <PrivateRoute path="/profile" component={ProfileView} />
          <PrivateRoute path="/blogs" component={BlogsView} />
          <PrivateRoute path="/services" component={ServicesView} />
          <PrivateRoute path="/businessguides" component={BusinessguideView}/> */}
          {/* <Route path="/experts" component={ExpertView}/>
          <PrivateRoute path="/graduates" component={GraduateView}/>
          <PrivateRoute path="/expert-tag-management" component={ExpertTagManagementView}/> */}
          <PrivateRoute path="/event-tag-management" component={EventTagManagementView}/>
          {/* <PrivateRoute path="/auth" component={AuthView}/> */}
          <PrivateRoute path="/events" component={EventsView}/>
          <PrivateRoute path="/member-offers" component={memberOffersView}/>
          <PrivateRoute path="/reports" component={ReportView}/>
          {/* <PrivateRoute path="/expertcat" component={ExpertCatReportView}/>
          <PrivateRoute path="/staff" component={StaffView}/>
          <PrivateRoute path="/keywords" component={KeywordsView}/> */}
          <PrivateRoute path="/members" component={MembersView}/>
          <PrivateRoute path="/credits" component={CreditsView}/>
          <PrivateRoute path="/emailcreator" component={EmailCreatorView}/>
          <PrivateRoute path="/flowcharts" component={FlowchartsView}/>
        </Switch>
      )}
      {/*<Chatbot chatbotThreadID={chatbotThreadID}/>*/}
    </>
  );
}

export default App;
